import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BillOfMaterial, ProductionOrderService, SplitBillOfMaterialData, SplitBillOfMaterialRowEntry } from 'chronos-core-client';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BillOfMaterialDsService {
  private billOfMaterialsSubject = new BehaviorSubject<BillOfMaterial[]>([]);
  public billOfMaterials$ = this.billOfMaterialsSubject.asObservable();
  private isBillOfMaterialsLoadingSubject = new BehaviorSubject<boolean>(false);
  public isBillOfMaterialsLoading$ = this.isBillOfMaterialsLoadingSubject.asObservable();

  private isBillOfMaterialDetailsLoadingSubject = new BehaviorSubject<boolean>(false);
  public isBillOfMaterialDetailsLoading$ = this.isBillOfMaterialDetailsLoadingSubject.asObservable();

  private isSplitBillOfMaterialLoadingSubject = new BehaviorSubject<boolean>(false);
  public isSplitBillOfMaterialLoading$ = this.isSplitBillOfMaterialLoadingSubject.asObservable();

  constructor(private productionOrderService: ProductionOrderService) {}

  public getBillOfMaterials(productionOrderId: number): Observable<BillOfMaterial[]> {
    this.isBillOfMaterialsLoadingSubject.next(true);
    this.billOfMaterialsSubject.next([]);

    this.productionOrderService.getBillOfMaterials({ productionOrderId }).subscribe(
      (data) => {
        this.billOfMaterialsSubject.next(data);
        this.isBillOfMaterialsLoadingSubject.next(false);
      },
      () => {
        this.isBillOfMaterialsLoadingSubject.next(false);
      }
    );

    return this.billOfMaterials$;
  }

  public getSplitBillOfMaterialDetails(productionOrderId: number, billOfMaterialId: number): Observable<SplitBillOfMaterialData> {
    this.isBillOfMaterialDetailsLoadingSubject.next(true);
    return this.productionOrderService
      .splitBillOfMaterialData({
        productionOrderId,
        billOfMaterialId
      })
      .pipe(finalize(() => this.isBillOfMaterialDetailsLoadingSubject.next(false)));
  }

  public splitBillOfMaterialRow(body: SplitBillOfMaterialRowEntry, productionOrderId: number): Observable<void> {
    this.isSplitBillOfMaterialLoadingSubject.next(true);
    return this.productionOrderService
      .splitBillOfMaterialRow({
        productionOrderId,
        body
      })
      .pipe(finalize(() => this.isSplitBillOfMaterialLoadingSubject.next(false)));
  }
}
